import { Typography } from '@mui/material';
import { Translate, type Translation } from '@shared/translation';

export interface FieldLabelProps {
  label?: Translation;
  required?: boolean;
  requiredLabel?: Translation;
}

export function FieldLabel({
  label,
  required = false,
  requiredLabel,
}: FieldLabelProps) {
  if (!label) {
    return null;
  }

  return (
    <Typography variant="body2">
      <Translate text={label} />
      {required && requiredLabel && (
        <>
          {' '}
          <Translate text={requiredLabel} />
        </>
      )}
    </Typography>
  );
}
